import { useEffect, useState, useCallback } from 'react';
import type { GoToPage } from '@tmsw/powerups.config.page.provider';
import { useStore } from '@tmsw/powerups.store';
import { usePageConfig } from '@tmsw/powerups.config.page.provider';
import { CTAButton } from '@tmsw/powerups.ui.buttons.cta-button';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { HeaderH1 } from '../../components/promo/HeaderH1';
import { usePauseConditions } from '../../hooks/usePauseConditions';
// import useResetFocus from '../../hooks/useResetFocus';
import './CameraAccess.css';

export type CameraAccessProps = {
  goToPage: GoToPage;
};

export const CameraAccess = ({ goToPage }: CameraAccessProps) => {
  const parentNode = 'CAMERA_ACCESS';
  const { __t } = useTranslation(parentNode);
  const { pagesMap } = usePageConfig();
  const externalPauseTriggered = usePauseConditions()();

  // local state
  // const [visibilityState, setVisibilityState] = useState(true);
  const [hasCameraAccess, setHasCameraAccess] = useState('initial');
  // @ts-ignore
  const [isFirefox] = useState(typeof InstallTrigger !== 'undefined');

  // global state
  const setGameLevel = useStore(useCallback((state) => state.setGameLevel, []));
  // const setPageTitle = useStore(useCallback((state) => state.setPageTitle, []));

  const setCameraAccessConsented = useStore(
    useCallback((state) => state.setCameraAccessConsented, [])
  );
  const cameraAccessConsented = useStore(
    (state) => state.cameraAccessConsented
  );
  // to check brower's camera permissions
  const checkCameraPermission = useCallback(
    async function checkCameraPermissionAsync() {
      // if(cameraAccessConsented == null) {
      // @ts-ignore
      const permission = await navigator.permissions.query({ name: 'camera' });
      if (permission.state === 'granted') {
        console.log('CAMERA PERMISSION IS GRANTED');
        //Needed to commmunicate with Zappar
        setHasCameraAccess('granted');
        // setCameraAccessConsented(true);
        /*this.app.fire('zappar:camera', { message: 'permission_granted', permission });
        this.app.fire('zappar:cameragranted');*/
      } else if (permission.state === 'prompt') {
        console.log('CAMERA PERMISSION IS PROMPT');
        setHasCameraAccess('prompt');
        // setCameraAccessConsented(null);
      } else if (permission.state === 'denied') {
        console.log('CAMERA PERMISSION IS DENIED');
        setHasCameraAccess('blocked');
        setCameraAccessConsented(false);
      }
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    []
  );

  // const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  // const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  // const inPortrait = useStore((state) => state.inPortrait);

  // useEffect(() => {
  //   setPageTitle(__t('pageTitle'));
  // }, [showSettingsPanel, isPauseEnabled, inPortrait]);

  // TODO: check if needed since SettingsDialog now sets focus on page change side-effect
  // useResetFocus([showSettingsPanel, inPortrait, isPauseEnabled]);

  // focus on setttingsButton on page mount
  // useEffect(() => {
  //   document.querySelector('#settingsButton')?.focus();
  // }, []);

  // check if browser is FF
  useEffect(() => {
    // setShowPauseBtnForPC(false);
    // setShowSkipBtnForPC(false);
  }, []);

  // if FF, skip checkCameraPermission()
  // useEffect(() => {
  //   if(isFirefox) {
  //     checkCameraAccess();
  //   }
  // })

  // handle document visibility (tab switch)
  // const handleVisibilityChange = useCallback(() => {
  //   setVisibilityState(document.visibilityState === 'visible');
  // }, []);

  const handleGyroPerm = async () => {
    if (
      window.DeviceOrientationEvent &&
      // @ts-ignore
      window.DeviceOrientationEvent.requestPermission
    ) {
      let permissionResult =
        // @ts-ignore
        await window.DeviceOrientationEvent.requestPermission();
      if (permissionResult !== 'granted') {
        // alert("Mod")
        return false;
      }
    }
  };

  // open promopt
  const checkCameraAccess = useCallback(async () => {
    await handleGyroPerm();
    let stream;
    try {
      stream = await navigator.mediaDevices.getUserMedia({ video: true });
      console.log('CAMERA PERMISSION IS GRANTED', stream);
      stream.getTracks().forEach((track) => track.stop());
      setHasCameraAccess('granted');
      setCameraAccessConsented(true);
      goToPage(3);
      // this.app.fire('zappar:camera', { message: 'permission_granted', stream });
      // this.app.fire('zappar:cameragranted');
    } catch (error: any) {
      if (error.name === 'NotAllowedError') {
        console.log('CAMERA PERMISSION IS DENIED');
        setHasCameraAccess('blocked');
        setCameraAccessConsented(false);
      } else if (error.name === 'NotFoundError') {
        console.log('CAMERA PERMISSION IS PROMPT');
        setHasCameraAccess('prompt');
        // setCameraAccessConsented(null);
      } else {
        console.error(error);
      }
    }
    if (isFirefox) {
      setHasCameraAccess('grant');
    }
  }, []);

  // set visibility state on component mount
  // useEffect(() => {
  //   document.addEventListener('visibilitychange', handleVisibilityChange);
  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, []);

  // useEffect(() => {
  //   setTimeout(() => {
  //     document.activeElement.blur();
  //     document.getElementById('settingsButton')?.focus();
  //   }, 200);
  // }, []);

  // FF: check perms on tab swtich
  useEffect(() => {
    if (isFirefox) {
      checkCameraAccess();
    }
  }, [isFirefox, checkCameraAccess]);

  // check camera permissions on component mount
  useEffect(() => {
    setHasCameraAccess('initial');
    // setCameraAccessConsented(null);
    setGameLevel(null);
    // setCharacterSelected(null)
    if (!isFirefox) {
      checkCameraPermission();
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  // check perms on tab switch or after externalPauseTriggered ends
  useEffect(() => {
    if (!isFirefox && !externalPauseTriggered) {
      checkCameraPermission();
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [externalPauseTriggered]);
  return (
    <section
      className="camera-access-container"
      style={{
        backgroundImage: `url(${__t('backgrounds.vignette', 'GENERAL')})`,
      }}
    >
      <div className="content-wrapper">
        <HeaderH1 textValue={__t('h1')} />
        <div className="camera-access-content">
          <div className="cta-container">
            {cameraAccessConsented === false ||
            hasCameraAccess === 'blocked' ? (
              <p className="bodyMessage">{__t('bodyCopyBlocked')}</p>
            ) : (
              <p className="bodyMessage">{__t('bodyCopy')}</p>
            )}
            <div className="cta-button-container">
              {cameraAccessConsented !== false && (
                <CTAButton
                  primary={hasCameraAccess !== 'blocked'}
                  intlKey="buttonGrant"
                  parentNode={parentNode}
                  onClick={() => {
                    goToPage(pagesMap.CARD_SCAN);
                    setCameraAccessConsented(true);
                  }}
                />
              )}
              <CTAButton
                primary={cameraAccessConsented === false}
                intlKey={
                  (!isFirefox &&
                    hasCameraAccess === 'prompt' &&
                    cameraAccessConsented !== false) ||
                  (hasCameraAccess === 'granted' &&
                    cameraAccessConsented !== false)
                    ? 'buttonDeny'
                    : 'buttonConsented'
                }
                parentNode={parentNode}
                onClick={() => {
                  setCameraAccessConsented(false);
                  goToPage(pagesMap.CHARACTER_SELECTION);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
